export const FETCH_CREATE_WASTE_REQUEST = 'FETCH_CREATE_WASTE_REQUEST'
export const FETCH_CREATE_WASTE_SUCCESS = 'FETCH_CREATE_WASTE_SUCCESS'
export const FETCH_CREATE_WASTE_FALUIRE = 'FETCH_CREATE_WASTE_FALUIRE'
